/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddOrRemoveDocumentToMeetingDto } from '../models/work-add-or-remove-document-to-meeting-dto';
import { WorkCreateMeetingDto } from '../models/work-create-meeting-dto';
import { WorkDocument } from '../models/work-document';
import { WorkMeeting } from '../models/work-meeting';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkTodo } from '../models/work-todo';
import { WorkUpdateMeetingDto } from '../models/work-update-meeting-dto';

@Injectable({ providedIn: 'root' })
export class WorkMeetingsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `meetingsV2ControllerFindAllPaginated()` */
  static readonly MeetingsV2ControllerFindAllPaginatedPath = '/v2/meetings';

  /**
   * Required permissions: meetings:read, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by organizerUserId query param.
     *           <p>
     *              <b>Format: </b> filter.organizerUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.organizerUserId=$not:$like:John Doe&filter.organizerUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.organizerUserId'?: Array<string>;

    /**
     * Filter by startAt query param.
     *           <p>
     *              <b>Format: </b> filter.startAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.startAt=$not:$like:John Doe&filter.startAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.startAt'?: Array<string>;

    /**
     * Filter by endAt query param.
     *           <p>
     *              <b>Format: </b> filter.endAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.endAt=$not:$like:John Doe&filter.endAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.endAt'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by participants.userId query param.
     *           <p>
     *              <b>Format: </b> filter.participants.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.participants.userId=$not:$like:John Doe&filter.participants.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.participants.userId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> startAt:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>title</li>
     * <li>startAt</li>
     * <li>organizerUserId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'title:ASC' | 'title:DESC' | 'startAt:ASC' | 'startAt:DESC' | 'organizerUserId:ASC' | 'organizerUserId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,description,location
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>description</li>
     * <li>location</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeeting>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'organizerUserId'?: (string | Array<string>);
'startAt'?: (string | Array<string>);
'endAt'?: (string | Array<string>);
'active'?: (string | Array<string>);
'participants.userId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.organizerUserId', params['filter.organizerUserId'], {});
      rb.query('filter.startAt', params['filter.startAt'], {});
      rb.query('filter.endAt', params['filter.endAt'], {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.participants.userId', params['filter.participants.userId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkMeeting>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'organizerUserId'?: (string | Array<string>);
        'startAt'?: (string | Array<string>);
        'endAt'?: (string | Array<string>);
        'active'?: (string | Array<string>);
        'participants.userId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: meetings:read, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 100
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by organizerUserId query param.
     *           <p>
     *              <b>Format: </b> filter.organizerUserId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.organizerUserId=$not:$like:John Doe&filter.organizerUserId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.organizerUserId'?: Array<string>;

    /**
     * Filter by startAt query param.
     *           <p>
     *              <b>Format: </b> filter.startAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.startAt=$not:$like:John Doe&filter.startAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.startAt'?: Array<string>;

    /**
     * Filter by endAt query param.
     *           <p>
     *              <b>Format: </b> filter.endAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.endAt=$not:$like:John Doe&filter.endAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.endAt'?: Array<string>;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by participants.userId query param.
     *           <p>
     *              <b>Format: </b> filter.participants.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.participants.userId=$not:$like:John Doe&filter.participants.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.participants.userId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> startAt:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>title</li>
     * <li>startAt</li>
     * <li>organizerUserId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'title:ASC' | 'title:DESC' | 'startAt:ASC' | 'startAt:DESC' | 'organizerUserId:ASC' | 'organizerUserId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title,description,location
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li>
     * <li>description</li>
     * <li>location</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkMeeting>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'organizerUserId'?: (string | Array<string>);
'startAt'?: (string | Array<string>);
'endAt'?: (string | Array<string>);
'active'?: (string | Array<string>);
'participants.userId'?: (string | Array<string>);
};
};
}> {
    return this.meetingsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeeting>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'organizerUserId'?: (string | Array<string>);
'startAt'?: (string | Array<string>);
'endAt'?: (string | Array<string>);
'active'?: (string | Array<string>);
'participants.userId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkMeeting>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'organizerUserId'?: (string | Array<string>);
'startAt'?: (string | Array<string>);
'endAt'?: (string | Array<string>);
'active'?: (string | Array<string>);
'participants.userId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `meetingsV2ControllerCreate()` */
  static readonly MeetingsV2ControllerCreatePath = '/v2/meetings';

  /**
   * Required permissions: meetings:create, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingsV2ControllerCreate$Response(
    params: {
      body: WorkCreateMeetingDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeeting>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeeting>;
      })
    );
  }

  /**
   * Required permissions: meetings:create, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingsV2ControllerCreate(
    params: {
      body: WorkCreateMeetingDto
    },
    context?: HttpContext
  ): Observable<WorkMeeting> {
    return this.meetingsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeeting>): WorkMeeting => r.body)
    );
  }

  /** Path part for operation `meetingsV2ControllerFindOneById()` */
  static readonly MeetingsV2ControllerFindOneByIdPath = '/v2/meetings/{id}';

  /**
   * Required permissions: meetings:read, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeeting>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeeting>;
      })
    );
  }

  /**
   * Required permissions: meetings:read, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeeting> {
    return this.meetingsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeeting>): WorkMeeting => r.body)
    );
  }

  /** Path part for operation `meetingsV2ControllerDelete()` */
  static readonly MeetingsV2ControllerDeletePath = '/v2/meetings/{id}';

  /**
   * Required permissions: meetings:delete, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeeting>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeeting>;
      })
    );
  }

  /**
   * Required permissions: meetings:delete, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeeting> {
    return this.meetingsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeeting>): WorkMeeting => r.body)
    );
  }

  /** Path part for operation `meetingsV2ControllerUpdate()` */
  static readonly MeetingsV2ControllerUpdatePath = '/v2/meetings/{id}';

  /**
   * Required permissions: meetings:update, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateMeetingDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeeting>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeeting>;
      })
    );
  }

  /**
   * Required permissions: meetings:update, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateMeetingDto
    },
    context?: HttpContext
  ): Observable<WorkMeeting> {
    return this.meetingsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeeting>): WorkMeeting => r.body)
    );
  }

  /** Path part for operation `meetingsV2ControllerReleaseProtocol()` */
  static readonly MeetingsV2ControllerReleaseProtocolPath = '/v2/meetings/{id}/release-protocol';

  /**
   * Required permissions: meetings:update, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerReleaseProtocol()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerReleaseProtocol$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeeting>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerReleaseProtocolPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeeting>;
      })
    );
  }

  /**
   * Required permissions: meetings:update, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerReleaseProtocol$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerReleaseProtocol(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeeting> {
    return this.meetingsV2ControllerReleaseProtocol$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeeting>): WorkMeeting => r.body)
    );
  }

  /** Path part for operation `meetingsV2ControllerFindOpenTodosFromTemplate()` */
  static readonly MeetingsV2ControllerFindOpenTodosFromTemplatePath = '/v2/meetings/{id}/open-todos-from-template';

  /**
   * Required permissions: meetings:read, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerFindOpenTodosFromTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerFindOpenTodosFromTemplate$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTodo>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerFindOpenTodosFromTemplatePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTodo>>;
      })
    );
  }

  /**
   * Required permissions: meetings:read, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerFindOpenTodosFromTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerFindOpenTodosFromTemplate(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTodo>> {
    return this.meetingsV2ControllerFindOpenTodosFromTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTodo>>): Array<WorkTodo> => r.body)
    );
  }

  /** Path part for operation `meetingsV2ControllerGetDocumentsByMeetingId()` */
  static readonly MeetingsV2ControllerGetDocumentsByMeetingIdPath = '/v2/meetings/{id}/documents';

  /**
   * Required permissions: meetings:read, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerGetDocumentsByMeetingId()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerGetDocumentsByMeetingId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerGetDocumentsByMeetingIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: meetings:read, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerGetDocumentsByMeetingId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerGetDocumentsByMeetingId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.meetingsV2ControllerGetDocumentsByMeetingId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `meetingsV2ControllerAddDocumentToMeeting()` */
  static readonly MeetingsV2ControllerAddDocumentToMeetingPath = '/v2/meetings/{id}/documents';

  /**
   * Required permissions: meetings:update, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerAddDocumentToMeeting()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingsV2ControllerAddDocumentToMeeting$Response(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToMeetingDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeeting>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerAddDocumentToMeetingPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeeting>;
      })
    );
  }

  /**
   * Required permissions: meetings:update, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerAddDocumentToMeeting$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingsV2ControllerAddDocumentToMeeting(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToMeetingDto
    },
    context?: HttpContext
  ): Observable<WorkMeeting> {
    return this.meetingsV2ControllerAddDocumentToMeeting$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeeting>): WorkMeeting => r.body)
    );
  }

  /** Path part for operation `meetingsV2ControllerRemoveDocumentFromMeeting()` */
  static readonly MeetingsV2ControllerRemoveDocumentFromMeetingPath = '/v2/meetings/{id}/documents/{documentId}';

  /**
   * Required permissions: meetings:update, meetings:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingsV2ControllerRemoveDocumentFromMeeting()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerRemoveDocumentFromMeeting$Response(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingsV2Service.MeetingsV2ControllerRemoveDocumentFromMeetingPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: meetings:update, meetings:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingsV2ControllerRemoveDocumentFromMeeting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingsV2ControllerRemoveDocumentFromMeeting(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.meetingsV2ControllerRemoveDocumentFromMeeting$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
